import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';

export const ADMIN_USER_FILTER_OPTIONS = [
  {
    field: 'email__icontains',
    label: 'Email',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'username__icontains',
    label: 'User Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'phone__icontains',
    label: 'Phone',
    type: FILTER_TYPES.TEXT,
  },
  { ...PAGE_SIZE_FILTER },
];
